import type { InvitableRoleName, OrganizationInvitationStatus } from '@/features/membership/types';

export const ROLE_LABELS: Record<InvitableRoleName, string> = {
  'Organization Admin': 'Admin Organisasi',
  Teacher: 'Guru',
  Student: 'Santri',
};

/**
 * Every role name the API can return, not only the invitable three -
 * `Parent` and the platform roles reach the UI through
 * `activeMembership.roleName` too. Falls back to the server's own name so
 * a role added later shows up readably instead of blank; the fallback is
 * the untranslated identifier, which is the honest thing to show when no
 * Indonesian label has been ratified for it.
 */
const EXTRA_ROLE_LABELS: Readonly<Record<string, string>> = {
  Parent: 'Wali',
  'Platform Super Admin': 'Super Admin Platform',
};

export function roleLabel(roleName: string): string {
  return (
    (ROLE_LABELS as Readonly<Record<string, string>>)[roleName] ??
    EXTRA_ROLE_LABELS[roleName] ??
    roleName
  );
}

export const STATUS_LABELS: Record<OrganizationInvitationStatus, string> = {
  PENDING: 'Menunggu',
  ACCEPTED: 'Diterima',
  CANCELLED: 'Dibatalkan',
};
